// extracted by mini-css-extract-plugin
export var table = "_ww-0";